import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import type { FeatureFlagConfig } from '#/app/shared/domain/configuration.model';
import { ConfigurationService } from '#/app/shared/services/configuration.service';

/**
 * Guard that verifies the route can be matched based on configuration feature flag being set to true
 */
export const featureFlagGuard = (
  featureFlag: keyof FeatureFlagConfig,
): CanMatchFn => {
  return () => {
    const configuration = inject(ConfigurationService);

    return configuration.configuration.featureFlags[featureFlag] ? true : false;
  };
};
